import { ProjectAccessService as OvermapProjectAccessService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProjectAccessService extends OvermapProjectAccessService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
